(function () {
  'use strict';

  var BRREG_API = 'https://data.brreg.no/enhetsregisteret/api/enheter/';
  var DEBOUNCE_MS = 600;

  function BedriftOrgNr(productFormEl) {
    this.el = productFormEl;
    this.wrapper = productFormEl.querySelector('[data-orgnr-wrapper]');
    this.input = productFormEl.querySelector('[data-orgnr-input]');
    this.statusEl = productFormEl.querySelector('[data-orgnr-status]');
    this.messageEl = productFormEl.querySelector('[data-orgnr-message]');
    this.submitBtn = productFormEl.querySelector('[type="submit"]');

    if (!this.input || !this.submitBtn) return;

    this._timer = null;

    // Lock the submit button until a valid org number is entered.
    // Only lock if the button isn't already disabled for another reason (e.g. sold out).
    if (!this.submitBtn.disabled) {
      this.submitBtn.disabled = true;
      this.submitBtn.dataset.orgnrLocked = 'true';
    }

    this.input.addEventListener('input', this._onInput.bind(this));
  }

  BedriftOrgNr.prototype._onInput = function () {
    var raw = this.input.value.replace(/[\s\-]/g, '');
    clearTimeout(this._timer);
    this._reset();

    if (!raw) return;

    if (!/^\d+$/.test(raw)) {
      this._setStatus('invalid', 'Kun sifre er tillatt.');
      return;
    }

    if (raw.length < 9) return;

    if (raw.length > 9) {
      this._setStatus('invalid', 'Organisasjonsnummeret er for langt (maks 9 sifre).');
      return;
    }

    // Exactly 9 digits — debounce then validate against Brønnøysund Register
    this._setStatus('loading', 'Validerer\u2026');
    var self = this;
    this._timer = setTimeout(function () { self._validate(raw); }, DEBOUNCE_MS);
  };

  BedriftOrgNr.prototype._validate = function (orgnr) {
    var self = this;
    fetch(BRREG_API + orgnr, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (res.status === 404) {
          self._setStatus(
            'invalid',
            'Organisasjonsnummeret ble ikke funnet i Br\u00f8nn\u00f8ysundregistrene.'
          );
          return null;
        }
        if (!res.ok) {
          self._setStatus('error', 'Validering feilet. Pr\u00f8v igjen.');
          return null;
        }
        return res.json();
      })
      .then(function (data) {
        if (!data) return;
        if (data.slettedato) {
          self._setStatus(
            'invalid',
            '\u00abOrganisasjonen ' + data.navn + '\u00bb er slettet fra registeret.'
          );
          return;
        }
        self._setStatus('valid', 'Gyldig: ' + data.navn);
        self._unlock();
        self._saveCartAttribute(orgnr, data.navn);
      })
      .catch(function (err) {
        self._setStatus('error', 'Nettverksfeil. Sjekk tilkoblingen og pr\u00f8v igjen.');
        console.error('[bedrift-orgnr]', err);
      });
  };

  BedriftOrgNr.prototype._reset = function () {
    this._setStatus('', '');
    if (this.submitBtn.dataset.orgnrLocked) {
      this.submitBtn.disabled = true;
    }
  };

  BedriftOrgNr.prototype._unlock = function () {
    if (this.submitBtn.dataset.orgnrLocked) {
      this.submitBtn.disabled = false;
    }
  };

  // Save to cart attributes immediately after validation so the value is
  // available in the cart drawer (and in the order) even if the customer
  // goes straight to checkout without opening the cart drawer first.
  BedriftOrgNr.prototype._saveCartAttribute = function (orgnr, firmanavn) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          Organisasjonsnummer: orgnr,
          Firmanavn: firmanavn
        }
      })
    }).catch(function (err) {
      console.error('[bedrift-orgnr] cart attribute update failed', err);
    });
  };

  BedriftOrgNr.prototype._setStatus = function (status, message) {
    if (this.wrapper) this.wrapper.dataset.status = status;
    if (this.statusEl) this.statusEl.dataset.status = status;
    if (this.messageEl) this.messageEl.textContent = message || '';
  };

  function init() {
    document.querySelectorAll('product-form[data-bedrift="true"]').forEach(function (el) {
      new BedriftOrgNr(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
